import { BusinessFunctionFeatureDto } from "./businessfunctionfeaturedto";
import { Features } from "../../enums/features";

export class ContentIsUpToDateFeatureDto extends BusinessFunctionFeatureDto {
    override $type: string;
    constructor(enabled: boolean) {
        super(Features.ContentIsUpToDate, "MultiJurisdictionCms.Dto.Features.ContentIsUpToDateFeatureDto, MultiJurisdictionCms.Dto");
        this.$type = "MultiJurisdictionCms.Dto.Features.ContentIsUpToDateFeatureDto, MultiJurisdictionCms.Dto";
        this.enabled = enabled;
    }
}